import { generateQueryString } from '@/utils/helpers'
import { baseApi } from '../baseApi'
import type { Dictionary } from '@/types'

export const userManagementApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAdmin: builder.query<Dictionary, Record<string, any>>({
      query: ({ id }) => ({
        url: `/users/${id}`,
        method: 'GET',
      }),
      providesTags: ['Admin'],
      transformResponse: (response: any) => response.data,
    }),
    getAdminDetails: builder.query<Dictionary, Record<string, any>>({
      query: ({ id }) => ({
        url: `/users/${id}/details`,
        method: 'GET',
      }),
      providesTags: ['Admin'],
      transformResponse: (response: any) => response.data,
    }),
    getAdmins: builder.query<
      {
        data: Dictionary[]
        total: number
        current_page: number
        per_page: number
      },
      Record<string, any>
    >({
      query: (param) => ({
        url: `/users${generateQueryString(param)}`,
        method: 'GET',
      }),
      providesTags: ['Admin'],
      transformResponse: (response: any) => response.data,
    }),
    getAdminSummary: builder.query({
      query: () => ({
        url: `/users/summary`,
        method: 'GET',
      }),
      providesTags: ['Admin'],
      transformResponse: (response: any) => response.data,
    }),
    getRoles: builder.query({
      query: () => ({
        url: `/users/roles`,
        method: 'GET',
      }),
      providesTags: ['Admin-role'],
      transformResponse: (response: any) => response.data,
    }),
    getRolesPaginated: builder.query<
      {
        data: Dictionary[]
        total: number
        current_page: number
        last_page: number
        per_page: number
        from: number
        to: number
        next_page_url: string | null
        prev_page_url: string | null
      },
      Record<string, any>
    >({
      query: (params) => ({
        url: `/users/roles${generateQueryString(params)}`,
        method: 'GET',
      }),
      providesTags: ['Admin-role'],
      transformResponse: (response: any) => response.data,
    }),
    updateAdmin: builder.mutation({
      query: ({ data, admin_id }) => ({
        url: `/users/${admin_id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Admin'],
    }),
    addAdmin: builder.mutation({
      query: (data) => ({
        url: `/users`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Admin'],
    }),
    deleteAdmin: builder.mutation({
      query: ({ admin_id }) => ({
        url: `/users/${admin_id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Admin'],
    }),
  }),
})

export const {
  useDeleteAdminMutation,
  useUpdateAdminMutation,
  useAddAdminMutation,
  useGetAdminQuery,
  useGetAdminDetailsQuery,
  useGetAdminsQuery,
  useGetRolesQuery,
  useGetRolesPaginatedQuery,
  useGetAdminSummaryQuery,
} = userManagementApi
